import { createBaseThemeOptions, createUnifiedTheme } from '@backstage/theme';
import {
  essityBrand,
  essityDarkIceSurface,
  essityOverlayOnDark,
} from './colours';
import { createEssityComponents } from './components';
import { createEssityDarkPalette } from './darkPalette';
import { createEssityPageTheme } from './essityPageTheme';
import { essityFontFamily, essityTypography } from './typography';

export const darkIceTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: createEssityDarkPalette(essityDarkIceSurface),
    typography: essityTypography,
  }),
  defaultPageTheme: 'home',
  fontFamily: essityFontFamily,
  components: {
    ...createEssityComponents(essityOverlayOnDark),
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h2: {
          textDecoration: 'underline',
        },
      },
    },
  },
  pageTheme: { home: createEssityPageTheme(essityBrand.white) },
});
